import React, { useEffect, useState, useCallback } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import AddUpdatePharmaSales from "./addUpdatePharmaSales";
import { getAllPhysician } from "../../../store/slices/physicianSlice";
import { getStateSlice } from "../../../store/slices/state";
// import { getAllStockSlice } from "../../../store/slices/stockInventorySlice";
import { getaccountType } from "../../../store/slices/accountType";
import { getBankListSlice } from "../../../store/slices/bankSlice";
import {
  createPharmaSalesSlice,
  updatePharmaSalesSlice,
  getAllPharmaSalesSlice,
  getPharmaSalesByIdSlice,
  resetUpdatePharmaSalesMessage,
  resetAddPharmaSalesMessage,
  cancelPharmaSalesSlice,
  resetCancelPharmaSalesMessage,
} from "../../../store/slices/pharmaSalesSlice";
import Table from "../../common/Table/table";
import ViewPharmaSalesDetails from "./viewPharmaSalesDetails";
import { useNavigate } from "react-router-dom";
import ViewPharmaInvoice from "./viewPharmaInvoice";

const PharmaSales = () => {
  const [showModal, setShowModal] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteSales, setDeleteSales] = useState(null);
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const [reportFromData, setReportFromData] = useState({
    fromDate: "",
    toDate: "",
  });
  const [viewModal, setViewModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const initialState = {
    patientName: "",
    patientId: "",
    billDate: "",
    billId: "",
    billedBy: "",
    prescribedBy: "",
    placeOfSupply: "",
    placeOfSupplyName: "",
    items: [],
    totalAmount: "",
    discount: "",
    discountPercent: "",
    subTotal: "",
    medicineRows: [],
    accountType: "",
    accountTypeName: "",
    bank: "",
    bankName: "",
    paymentStatus: "UNPAID",
    receivedBy: "",
  };

  const [salesFormData, setSalesFormData] = useState(initialState);

  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { userInfo, token } = useSelector((state) => state.auth);
  const { paymentStatus } = useSelector((state) => state.tablePaidStatus);
  const navigate = useNavigate();
 const clinicId =clinicInfo?.[0]?.clinicId || null;
  const fetchPharmaSales = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getAllPharmaSalesSlice({
            clinicId,
            token,
            paymentStatus: paymentStatus,
            // currentPage: page,
            // limit: lim,
            search: search || undefined,
            fromDate: reportFromData.fromDate || undefined,
            toDate: reportFromData.toDate || undefined,
          })
        );
      }
    },
    [
      dispatch,
      clinicId,
      token,
      paymentStatus,
      pageLimit,
      searchValue,
      reportFromData.fromDate,
      reportFromData.toDate,
    ]
  );

  useEffect(() => {
    if (clinicId && token) {
      fetchPharmaSales(1, pageLimit, searchValue);
    }
  }, [clinicInfo, token, pageLimit, searchValue, paymentStatus, fetchPharmaSales]);

  const handlePageChange = (page) => {
    fetchPharmaSales(page, pageLimit, searchValue);
  };

  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchPharmaSales(1, newLimit, searchValue);
  };

  useEffect(() => {
    dispatch(
      getAllPhysician({
        clinicId,
        clinicStatus: "Accepted",
        physicianStatus: "Accepted",
        token,
      })
    );
    dispatch(getStateSlice({ token }));
    // dispatch(
    //   getAllStockSlice({
    //     clinicId,
    //     token,
    //   })
    // );
    dispatch(getaccountType({ status: ["Active"], token }));
    dispatch(
      getBankListSlice({
        status: ["Active"],
        clinicId,
        token,
      })
    );
  }, [dispatch, token, clinicId, showModal, setShowModal]);
  const { physician } = useSelector((state) => state.physician);
  const { state } = useSelector((state) => state.state);
  const { stockInventory } = useSelector((state) => state.stockInventory);
  const {
    pharmaSales,
    createPharmaSalesSuccessMessage,
    createPharmaSalesErrorMessage,
    updatePharmaSalesSuccessMessage,
    updatePharmaSalesErrorMessage,
    searchPharmaSalesErrorMessage,
    cancelPharmaSalesSuccessMessage,
    cancelPharmaSalesErrorMessage,
    currentPage,
    totalPages,
    totalCount,
    isLoading,
  } = useSelector((state) => state.pharmaSales);
  const { accountType } = useSelector((state) => state.accountType);
  const { bank } = useSelector((state) => state.bank);

  const [purchaseFormData, setPurchaseFormData] = useState(initialState);
  const [inputError, setInputError] = useState({
    supplier: false,
    invoiceId: false,
    invoiceDate: false,
  });

  useEffect(() => {
    showTostifyMessageAndReset(
      createPharmaSalesSuccessMessage,
      showToastifySuccess,
      resetAddPharmaSalesMessage
    );
    showTostifyMessageAndReset(
      createPharmaSalesErrorMessage,
      showToastifyError,
      resetAddPharmaSalesMessage
    );
    showTostifyMessageAndReset(
      updatePharmaSalesSuccessMessage,
      showToastifySuccess,
      resetUpdatePharmaSalesMessage
    );
    showTostifyMessageAndReset(
      updatePharmaSalesErrorMessage,
      showToastifyError,
      resetUpdatePharmaSalesMessage
    );
    showTostifyMessageAndReset(
      cancelPharmaSalesSuccessMessage,
      showToastifySuccess,
      resetCancelPharmaSalesMessage
    );
    showTostifyMessageAndReset(
      cancelPharmaSalesErrorMessage,
      showToastifyError,
      resetCancelPharmaSalesMessage
    );
  }, [
    createPharmaSalesSuccessMessage,
    createPharmaSalesErrorMessage,
    updatePharmaSalesSuccessMessage,
    updatePharmaSalesErrorMessage,
    showTostifyMessageAndReset,
    cancelPharmaSalesErrorMessage,
    cancelPharmaSalesSuccessMessage,
  ]);
  const [userInput, setUserInput] = useState({
    name: false,
    email: false,
    phone: false,
  });
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];
  const handleSelectChange = (selectedOption, name) => {
    if (name === "patient") {
      setSalesFormData({
        ...salesFormData,
        patientId: selectedOption?.value,
        patientName: selectedOption?.label,
      });
    } else if (name === "accountType") {
      setSalesFormData({
        ...salesFormData,
        accountType: selectedOption?.value,
        accountTypeName: selectedOption?.label,
        bank: "",
        bankName: "",
      });
    } else if (name === "bank") {
      setSalesFormData({
        ...salesFormData,
        bank: selectedOption?.value,
        bankName: selectedOption?.label,
      });
    }
  };

  const handlePrescriberChange = (selectedOption, name) => {
    setSalesFormData({
      ...salesFormData,
      prescribedBy: selectedOption?.value,
    });
  };

  const handlePlaceChange = (selectedOption, name) => {
    setSalesFormData({
      ...salesFormData,
      placeOfSupply: selectedOption?.value,
      placeOfSupplyName: selectedOption?.label,
    });
  };

  const setPaymentStatus = (value) => {
    setSalesFormData((prev) => ({
      ...prev,
      items: prev.items ?? [],
      paymentStatus: value,
    }));
  };

  const handleModal = (action, sales = null) => {
    if (action === "edit" || (action === "refund" && sales)) {
      setSalesFormData({
        salesId: sales?._id,
        patientId: sales?.patientId?._id,
        patientName: sales?.patientId?.userId?.name,
        invoiceId: sales?.invoiceId,
        invoiceDate: sales?.invoiceDate?.split("T")[0],
        prescribedBy: sales?.prescribedBy,
        placeOfSupply: sales?.placeOfSupply?._id,
        placeOfSupplyName: sales?.placeOfSupply?.name,
        subTotal: sales?.subTotal,
        items: sales?.item || [],
        afterDiscount: sales?.afterDiscount,
        discount: sales?.discount,
        discountPercent: sales?.discountPercent,
        paymentStatus: sales?.paymentStatus,
        isAlreadyPaid: sales?.paymentStatus === "PAID",
        accountType: sales?.accountType?._id,
        accountTypeName: sales?.accountType?.name,
        bank: sales?.bank?._id,
        bankName: sales?.bank?.name,
      });
    } else if (action === "create") {
      setSalesFormData({ ...initialState, isAlreadyPaid: false });
    }
    setShowModal(true);
    setModalAction(action);
  };
  const handleAddUpdate = async ({
    medicineRows,
    discountType,
    discountValue,
  }) => {
    const subTotal = medicineRows.reduce(
      (sum, item) => sum + Number(item?.total || 0),
      0
    );
    let discount = 0;
    let percent = 0;

    if (discountType === "percent") {
      percent = parseFloat(discountValue) || 0;
      discount = (subTotal * percent) / 100;
    } else {
      discount = parseFloat(discountValue) || 0;
      percent = (discount / subTotal) * 100;
    }

    const net = subTotal - discount;

    const salesPayload = {
      ...salesFormData,
      item: medicineRows,
      subTotal,
      discount,
      discountPercent: percent,
      afterDiscount: net,
      clinicId,
      token,
      createdBy: userInfo?._id,
      billedBy: userInfo?._id,
      receivedBy:
        salesFormData?.paymentStatus === "PAID" ? userInfo?._id : null,
      paymentDate:
        salesFormData?.paymentStatus === "PAID" ? formattedDate : null,
      paidAmount:
        salesFormData?.paymentStatus === "PAID"
          ? net
          : null,
      isAlreadyPaid: salesFormData?.paymentStatus === "PAID" ? true : false,
    };

    let response;
    if (modalAction === "edit" && salesPayload?.salesId) {
      response = await dispatch(
        updatePharmaSalesSlice({
          id: salesPayload?.salesId,
          paymentStatus: salesFormData?.paymentStatus,
          clinicId,
          token: token,
          bank: salesFormData?.bank,
          accountType: salesFormData?.accountType,
          discount: discount,
          discountPercent: percent,
          afterDiscount: net,
          paymentDate: salesFormData?.paymentStatus === "PAID" && formattedDate,
          paidAmount: salesFormData?.afterDiscount,
          receivedBy:
            salesFormData?.paymentStatus === "PAID" ? userInfo?._id : null,
          updatedBy: userInfo?._id,
        })
      );
    } else {
      response = await dispatch(createPharmaSalesSlice(salesPayload));
    }
    if (response?.payload?.success) {
      dispatch(
        getAllPharmaSalesSlice({
          clinicId,
          token,
          paymentStatus: paymentStatus,
        })
      );
      setSalesFormData(initialState);
      setShowModal(false);
    }
  };
  const tableHead = [
    { title: "Patient Name", key: "patientName" },
    { title: "Invoice Date", key: "invoiceDate" },
    { title: "Amount", key: "amount" },
    { title: "Status", key: "status" },
  ];

  const handleEdit = async (sales) => {
    try {
      const res = await dispatch(
        getPharmaSalesByIdSlice({ id: sales?.id, token })
      );
      const salesData = res?.payload?.result?.list;
      setSalesFormData({
        salesId: salesData?._id,
        patientId: salesData?.patientId?._id,
        patientName: salesData?.patientId?.userId?.name,
        invoiceId: salesData?.billDate,
        invoiceDate: salesData?.invoiceDate?.split("T")[0],
        prescribedBy: salesData?.prescribedBy,
        placeOfSupply: salesData?.placeOfSupply?._id,
        placeOfSupplyName: salesData?.placeOfSupply?.name,
        subTotal: salesData?.subTotal,
        items: salesData?.item || [],
        afterDiscount: salesData?.afterDiscount,
        discount: salesData?.discount,
        discountPercent: salesData?.discountPercent,
        paymentStatus: salesData?.paymentStatus,
        accountType: salesData?.accountType?._id,
        accountTypeName: salesData?.accountType?.name,
        bank: salesData?.bank?._id,
        bankName: salesData?.bank?.name,
      });
      handleModal("edit", salesData);
    } catch (error) {
      console.error("Failed to get Sales Data: Please Try Later..", error);
    }
  };
  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchValue(value);
      fetchPharmaSales(1, pageLimit, value);
    },
    [fetchPharmaSales, pageLimit]
  );

  const handleFilter = useCallback(async () => {
    await dispatch(
      getAllPharmaSalesSlice({
        clinicId,
        fromDate: reportFromData.fromDate,
        toDate: reportFromData.toDate,
        paymentStatus: paymentStatus,
        token,
        currentPage: 1,
        limit: pageLimit,
      })
    );
  }, [dispatch, clinicInfo, reportFromData, token, paymentStatus, pageLimit]);

  const handleClear = useCallback(async () => {
    setReportFromData({ fromDate: "", toDate: "" });
    fetchPharmaSales(1, pageLimit, searchValue);
  }, [fetchPharmaSales, pageLimit, searchValue]);


  const handleShowGlobalViewModal = async (data) => {
    const res = await dispatch(
      getPharmaSalesByIdSlice({ id: data?.id, token })
    );
    const salesData = res?.payload?.result?.list;
    setSalesFormData({
      salesId: salesData?._id,
      patientId: salesData?.patientId?._id,
      patientName: salesData?.patientId?.userId?.name,
      invoiceId: salesData?.billDate,
      invoiceDate: salesData?.invoiceDate?.split("T")[0],
      prescribedBy: salesData?.prescribedBy,
      placeOfSupply: salesData?.placeOfSupply?._id,
      placeOfSupplyName: salesData?.placeOfSupply?.name,
      subTotal: salesData?.subTotal,
      items: salesData?.item || [],
      afterDiscount: salesData?.afterDiscount,
      discount: salesData?.discount,
      discountPercent: salesData?.discountPercent,
      paymentStatus: salesData?.paymentStatus,
      accountType: salesData?.accountType?._id,
      accountTypeName: salesData?.accountType?.name,
      bank: salesData?.bank?._id,
      bankName: salesData?.bank?.name,
    });
    setViewModal(true);
  };

  /* For Refund */
  const handleRefund = async (sales) => {
    try {
      const res = await dispatch(
        getPharmaSalesByIdSlice({ id: sales?.id, token })
      );
      const salesData = res?.payload?.result?.list;
      setSalesFormData({
        salesId: salesData?._id,
        patientId: salesData?.patientId?._id,
        patientName: salesData?.patientId?.userId?.name,
        invoiceId: salesData?.billDate,
        invoiceDate: salesData?.invoiceDate?.split("T")[0],
        prescribedBy: salesData?.prescribedBy,
        placeOfSupply: salesData?.placeOfSupply?._id,
        placeOfSupplyName: salesData?.placeOfSupply?.name,
        subTotal: salesData?.subTotal,
        items: salesData?.item || [],
        afterDiscount: salesData?.afterDiscount,
        discount: salesData?.discount,
        discountPercent: salesData?.discountPercent,
        paymentStatus: salesData?.paymentStatus,
        accountType: salesData?.accountType?._id,
        accountTypeName: salesData?.accountType?.name,
        bank: salesData?.bank?._id,
        bankName: salesData?.bank?.name,
      });
      handleModal("refund", salesData);
    } catch (error) {
      console.error("Failed to get Sales Data: Please Try Later..", error);
    }
  };

  const refundMedicines = async (med) => {
    setShowRefundModal(true);
  };

  /* For Cancel */
  const handleCancelSales = async () => {
    try {
      await dispatch(
        cancelPharmaSalesSlice({
          saleId: deleteSales,
          clinicId,
          cancelledBy: userInfo?._id,
          token,
        })
      );
      setDeleteModal(false);
      dispatch(
        getAllPharmaSalesSlice({
          clinicId,
          token,
          paymentStatus: paymentStatus,
        })
      );
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  const handleCancel = async (Id) => {
    setDeleteSales(Id.id);
    setDeleteModal(true);
  };

  const PharmaMyCollection = (startDate, endDate, receivedBy) => {
    navigate(`/pharmaMyCollection`, {
      state: { startDate, endDate, receivedBy: userInfo?._id },
    });
  };
  const handlePrint = (salesId) => {
    navigate(`/viewPharmaInvoice`);
    sessionStorage.setItem("salesId", salesId.id);
  };
  return (
    <>
      <div className="row">
        <div className="col-md-2">
          <div className="form-group form-focus focused">
            <label className="focus-label">From</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.fromDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    fromDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group form-focus focused">
            <label className="focus-label">To</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.toDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    toDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>

        <div className="col-md-3 mt-2">
          <button className="btn btn-primary mt-3" onClick={handleFilter}>
            Filter
          </button>
          <button className="btn btn-danger mt-3 ms-3" onClick={handleClear}>
            Clear
          </button>
        </div>
        <div className="col-md-2 mt-4">
          <button
            className="btn btn-primary"
            onClick={() => PharmaMyCollection()}
          >
            My Collection
          </button>
        </div>
      </div>
      <>
        <div className="container mt-4">
          <Table
            tableHead={tableHead}
            tableBody={
              pharmaSales &&
              pharmaSales?.map((item) => ({
                id: item?._id,
                patientName: item?.patientId?.userId?.name || "N/A",
                invoiceDate: item?.billDate?.split("T")[0] || "N/A",
                amount: item?.afterDiscount || "N/A",
                status: item?.paymentStatus || "N/A",
              }))
            }
            handleAddBtn={true}
            handleSearchOption={true}
            searchValue={searchValue}
            handleSearch={handleSearch}
            errorMessage={searchPharmaSalesErrorMessage}
            handleShowGlobalViewModal={handleShowGlobalViewModal}
            handleEdit={handleEdit}
            addModal={() => handleModal("create")}
            handleShare={false}
           showPaymentStatusTab={false}
            hideStatusTab={false}
            handleRefund={handleRefund}
            handleCancel={handleCancel}
            payemntHeaderColor="paymentTabcolor"
            handlePrint={handlePrint}
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            limit={pageLimit}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
            showPagination={true}
            showLimitDropdown={true}
            isLoading={isLoading}
          />

          <AddUpdatePharmaSales
            showModal={showModal}
            setShowModal={setShowModal}
            handleAddUpdate={handleAddUpdate}
            salesFormData={salesFormData}
            setSalesFormData={setSalesFormData}
            handleSelectChange={handleSelectChange}
            handlePlaceChange={handlePlaceChange}
            handlePrescriberChange={handlePrescriberChange}
            physician={physician}
            modalAction={modalAction}
            setInputError={setInputError}
            userInput={userInput}
            state={state}
            medicines={stockInventory}
            accountType={accountType}
            bank={bank}
            setPaymentStatus={setPaymentStatus}
            refundMedicines={refundMedicines}
          />
          <ViewPharmaSalesDetails
            show={viewModal}
            onHide={() => setViewModal(false)}
            salesData={salesFormData}
          />
          <Modal
            centered
            show={deleteModal}
            onHide={() => setDeleteModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Are You Sure Want to Cancel it?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              After Cancellation, you won't be able to recover the data
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                onClick={() => setDeleteModal(false)}
                className="p-2"
              >
                Back to Page
              </Button>
              <Button
                variant="danger"
                className="p-2"
                onClick={handleCancelSales}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    </>
  );
};

export default PharmaSales;
